let _app_conf =
{
    qa_filters:
    {
        tags:
        {
            default: {id:'ALL', label: 'ALL', value: 'ALL'}
        }
    },
    app_state:
    {
        default:
        {
            text: '',
            filters: {}
        }
    }
};

_app_conf.DEBUG_MODE = true;

export default _app_conf;